var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgNewFkcroplogo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 450,
    height: 276,
    viewBox: "0 0 450 276",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_76",
    "data-name": "Path 76",
    d: "M182.217,16.941l57.51,57.51a30.23,30.23,0,0,1,0,42.687l-54.752,54.743L168.3,155.212l-6.343-6.357-7.911,7.911-8.614-8.614,8.479-8.479-4.375-4.375,28.865-28.834a15.115,15.115,0,0,0,0-21.341L146.792,53.51l4.375-4.375-8.474-8.5,8.614-8.6,1.541,1.541,3,2.982,3.361,3.374,15.111-15.111,7.9-7.911ZM148.058,185.789l4.1-4.1-4.1-4.1-4.086,4.1Zm-18.472-11.862,3.1-3.1-3.1-3.109-3.109,3.109Zm4.3,10.231,3.874-3.875-3.874-3.888L130,180.283Zm-14.962-7.474,2.9-2.9-2.9-2.9-2.9,2.9Zm-8.763-5.068,1.2-1.2-1.2-1.2-1.189,1.2Zm8.479-4.663,1.766-1.766-1.766-1.766-1.766,1.766Zm8.56-7.551,2.609-2.609-2.609-2.609-2.609,2.609Zm6.848,6.145,2.82-2.82-2.82-2.834-2.834,2.834ZM142.3,146.7l4.591-4.591-4.591-4.591-4.591,4.591Zm-5.654,7.208,3.109-3.109-3.109-3.1-3.1,3.1Zm7.56,9.529,5.154-5.154-5.154-5.154-5.154,5.154Zm-3.6,12.277,4.375-4.375-4.375-4.375-4.375,4.375Zm8.191-4.375,3.676-3.676-3.676-3.676-3.676,3.676Zm8.317-6.934,4.591-4.591-4.591-4.6-4.591,4.591Zm1.829,15.111,6.069-6.069-6.069-6.069-6.064,6.037Zm4.8,9.317,6.343-6.357-6.339-6.357-6.357,6.357Zm8.56-9.668,4.1-4.1-4.1-4.1-4.086,4.1Zm-11.849-16.025,8.754,8.754,7.9-7.911,8.754-8.754-8.754-8.754-8.754,8.754-3.361,3.374-3,2.982ZM145.31,3.033l4.1,4.1-4.1,4.1-4.1-4.1ZM126.816,14.9,129.925,18l-3.109,3.1-3.1-3.113,3.1-3.109Zm4.3-10.231,3.888,3.875-3.888,3.888-3.875-3.888,3.875-3.875Zm-14.962,7.465,2.9,2.9-2.9,2.9-2.9-2.9ZM107.4,17.22l1.2,1.189-1.2,1.2-1.2-1.176Zm8.479,4.654,1.766,1.766-1.766,1.766-1.766-1.766Zm8.56,7.56,2.609,2.609-2.609,2.609-2.609-2.609Zm6.848-6.145,2.82,2.82-2.82,2.834-2.82-2.834Zm8.249,18.855,4.591,4.591-4.591,4.591-4.591-4.591Zm-5.654-7.208,3.109,3.109-3.109,3.109-3.109-3.109Zm7.551-9.529,5.154,5.154-5.154,5.154-5.154-5.154Zm-3.6-12.277,4.375,4.375-4.375,4.375L133.457,17.5Zm8.191,4.375L149.7,21.18l-3.676,3.676-3.676-3.676,3.676-3.676Zm8.326,6.92,4.564,4.6-4.591,4.591-4.591-4.591Zm1.829-15.111,6.069,6.069-6.069,6.069-6.069-6.069Zm4.8-9.3,6.357,6.343-6.357,6.361-6.343-6.357Zm8.56,9.668,4.1,4.1-4.1,4.1-4.1-4.1ZM157.65,25.7,166.4,16.95l16.669,16.669-8.754,8.754-8.754-8.754-3.374-3.361-4.541-4.541Z",
    transform: "translate(-106.2 -0.01)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: -88.937,
    y1: 56.696,
    x2: -6.843,
    y2: 55.826,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#c4a449"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#c3a449"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#c2a549"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.01,
    stopColor: "#c0a549"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.02,
    stopColor: "#bfa549"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.02,
    stopColor: "#bea649"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.02,
    stopColor: "#bda649"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.03,
    stopColor: "#bca649"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.03,
    stopColor: "#bba749"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.04,
    stopColor: "#baa749"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.04,
    stopColor: "#b8a849"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.04,
    stopColor: "#b7a848"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.05,
    stopColor: "#b6a848"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.05,
    stopColor: "#b5a948"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.05,
    stopColor: "#b4a948"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.06,
    stopColor: "#b3a948"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.06,
    stopColor: "#b1aa48"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#b0aa48"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#afaa48"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#aeab48"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.08,
    stopColor: "#adab48"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.08,
    stopColor: "#acac48"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.09,
    stopColor: "#abac48"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.09,
    stopColor: "#a9ac48"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.09,
    stopColor: "#a8ad48"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#a7ad47"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#a6ad47"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.11,
    stopColor: "#a5ae47"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.11,
    stopColor: "#a4ae47"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.11,
    stopColor: "#a2af47"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.12,
    stopColor: "#a1af47"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.12,
    stopColor: "#a0af47"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.12,
    stopColor: "#9fb047"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.13,
    stopColor: "#9eb047"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.13,
    stopColor: "#9db047"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.14,
    stopColor: "#9cb147"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.14,
    stopColor: "#9ab147"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.14,
    stopColor: "#99b147"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#98b246"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#97b246"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.16,
    stopColor: "#96b346"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.16,
    stopColor: "#95b346"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.16,
    stopColor: "#94b346"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.17,
    stopColor: "#92b446"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.17,
    stopColor: "#91b446"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.18,
    stopColor: "#90b446"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.18,
    stopColor: "#8fb546"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.18,
    stopColor: "#8eb546"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.19,
    stopColor: "#8db646"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.19,
    stopColor: "#8bb646"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#8ab646"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#89b746"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#88b745"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.21,
    stopColor: "#87b745"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.21,
    stopColor: "#86b845"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.21,
    stopColor: "#85b845"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.22,
    stopColor: "#83b845"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.22,
    stopColor: "#82b945"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.23,
    stopColor: "#81b945"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.23,
    stopColor: "#80ba45"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.23,
    stopColor: "#7fba45"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.24,
    stopColor: "#7eba45"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.24,
    stopColor: "#7cbb45"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#7bbb45"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#7abb45"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#79bc45"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.26,
    stopColor: "#78bc44"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.26,
    stopColor: "#77bc44"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.27,
    stopColor: "#76bd44"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.27,
    stopColor: "#74bd44"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.27,
    stopColor: "#73be44"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.28,
    stopColor: "#72be44"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.28,
    stopColor: "#72be45"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#71bd46"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#70bc47"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#70bc48"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#6fbc49"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#6fbb49"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.31,
    stopColor: "#6ebb4a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.31,
    stopColor: "#6eba4b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.32,
    stopColor: "#6dba4c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.32,
    stopColor: "#6dba4d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.32,
    stopColor: "#6cb94d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.33,
    stopColor: "#6cb94e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.33,
    stopColor: "#6bb94f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.34,
    stopColor: "#6bb850"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.34,
    stopColor: "#6ab850"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.34,
    stopColor: "#6ab751"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#69b752"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#69b753"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.36,
    stopColor: "#68b654"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.36,
    stopColor: "#67b555"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.37,
    stopColor: "#67b556"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.37,
    stopColor: "#66b557"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.38,
    stopColor: "#66b457"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.38,
    stopColor: "#65b458"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.38,
    stopColor: "#65b359"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.39,
    stopColor: "#64b35a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.39,
    stopColor: "#63b25b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#63b25c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#62b15d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.41,
    stopColor: "#62b15e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.41,
    stopColor: "#61b05f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#61b060"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#60af61"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#60af61"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#5faf62"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#5fae63"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.44,
    stopColor: "#5eae64"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.44,
    stopColor: "#5eae65"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.45,
    stopColor: "#5dad65"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.45,
    stopColor: "#5dad66"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.45,
    stopColor: "#5cac67"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.46,
    stopColor: "#5cac68"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.46,
    stopColor: "#5bac68"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.46,
    stopColor: "#5bab69"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.47,
    stopColor: "#5aab6a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.47,
    stopColor: "#5aaa6b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    stopColor: "#59aa6c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    stopColor: "#58a96d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.49,
    stopColor: "#58a96e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.49,
    stopColor: "#57a86f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#57a86f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#56a870"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#56a771"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    stopColor: "#55a772"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    stopColor: "#55a672"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    stopColor: "#54a673"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    stopColor: "#54a674"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    stopColor: "#53a575"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53,
    stopColor: "#53a576"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53,
    stopColor: "#52a576"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#52a477"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#52a478"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#51a379"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.55,
    stopColor: "#51a379"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.55,
    stopColor: "#50a37a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.55,
    stopColor: "#50a27b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.56,
    stopColor: "#4fa27c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.56,
    stopColor: "#4fa17d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.57,
    stopColor: "#4ea17d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.57,
    stopColor: "#4ea17e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.57,
    stopColor: "#4da07f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.58,
    stopColor: "#4da080"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.58,
    stopColor: "#4c9f80"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59,
    stopColor: "#4c9f81"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59,
    stopColor: "#4b9f82"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59,
    stopColor: "#4b9e83"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#4a9e84"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#4a9d84"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.61,
    stopColor: "#499d85"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.61,
    stopColor: "#499d86"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.61,
    stopColor: "#489c87"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.62,
    stopColor: "#489c87"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.62,
    stopColor: "#479b88"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.62,
    stopColor: "#479b89"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.63,
    stopColor: "#469b8a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.63,
    stopColor: "#469a8a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.64,
    stopColor: "#459a8b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.64,
    stopColor: "#459a8c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.64,
    stopColor: "#44998d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.65,
    stopColor: "#44998e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.65,
    stopColor: "#43988e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#43988f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#429890"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#429791"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.67,
    stopColor: "#419791"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.67,
    stopColor: "#419692"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.68,
    stopColor: "#419693"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.68,
    stopColor: "#409694"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.68,
    stopColor: "#409595"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.69,
    stopColor: "#3f9595"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.69,
    stopColor: "#3f9496"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7,
    stopColor: "#3e9497"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7,
    stopColor: "#3e9498"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7,
    stopColor: "#3d9398"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.71,
    stopColor: "#3d9399"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.71,
    stopColor: "#3c929a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.71,
    stopColor: "#3c929b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.72,
    stopColor: "#3b929c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.72,
    stopColor: "#3b919c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.73,
    stopColor: "#3a919d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.73,
    stopColor: "#3a919e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.73,
    stopColor: "#39909f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.74,
    stopColor: "#39909f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.74,
    stopColor: "#388fa0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "#388fa1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "#378fa2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "#378ea3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#368ea3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#368da4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.77,
    stopColor: "#358da5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.77,
    stopColor: "#358da6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.77,
    stopColor: "#348ca6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.78,
    stopColor: "#348ca7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.78,
    stopColor: "#338ba8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.79,
    stopColor: "#338ba9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.79,
    stopColor: "#328ba9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.79,
    stopColor: "#328aaa"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "#318aab"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "#3189ac"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "#3189ad"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.81,
    stopColor: "#3089ad"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.81,
    stopColor: "#3088ae"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.82,
    stopColor: "#2f88af"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.82,
    stopColor: "#2f88b0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.82,
    stopColor: "#2e87b0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.83,
    stopColor: "#2e87b1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.83,
    stopColor: "#2d86b2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#2d86b3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#2c86b4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#2c85b4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.85,
    stopColor: "#2b85b5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.85,
    stopColor: "#2b84b6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.86,
    stopColor: "#2a84b7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.86,
    stopColor: "#2983b8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.87,
    stopColor: "#2983b9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.87,
    stopColor: "#2882ba"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.88,
    stopColor: "#2882bb"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.88,
    stopColor: "#2782bb"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.88,
    stopColor: "#2781bc"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.89,
    stopColor: "#2681bd"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.89,
    stopColor: "#2680be"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.89,
    stopColor: "#2580be"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#2580bf"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#247fc0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#247fc1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#237ec1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#237ec2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.92,
    stopColor: "#227ec3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.92,
    stopColor: "#227dc4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.93,
    stopColor: "#217dc5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.93,
    stopColor: "#217cc6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.94,
    stopColor: "#207cc7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.94,
    stopColor: "#207bc8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.95,
    stopColor: "#1f7bc8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.95,
    stopColor: "#1f7bc9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.95,
    stopColor: "#1e7aca"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.96,
    stopColor: "#1e7acb"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.96,
    stopColor: "#1d79cc"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.97,
    stopColor: "#1c79cd"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.97,
    stopColor: "#1c78ce"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.98,
    stopColor: "#1b78cf"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.98,
    stopColor: "#1b77cf"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.98,
    stopColor: "#1a77d0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    stopColor: "#1a77d1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    stopColor: "#1976d2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1976d2"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_516",
    "data-name": "Group 516",
    transform: "translate(2829 354)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_561",
    "data-name": "Rectangle 561",
    width: 450,
    height: 276,
    transform: "translate(-2829 -354)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_515",
    "data-name": "Group 515",
    transform: "translate(224.352 81.758)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_21",
    "data-name": "Path 21",
    d: "M66.625,174.24l-.414.189a19.4,19.4,0,0,0-2.293-4.239,17.616,17.616,0,0,0-7.938-6.082,14.294,14.294,0,0,0-5.222-.964,16.363,16.363,0,0,0-3.789.365,5.2,5.2,0,0,0-2.253,1.1,3.352,3.352,0,0,0-1.041,1.829,12.579,12.579,0,0,0-.239,2.636v5.357h6.92a5.74,5.74,0,0,0,4.023-1.18,6.015,6.015,0,0,0,1.667-3.424l.577-.1,2.7,18.571-.6.077a13.515,13.515,0,0,0-1.667-4.8,10.282,10.282,0,0,0-2.582-2.924,9.068,9.068,0,0,0-3.01-1.469,12.032,12.032,0,0,0-3.009-.414H43.414V207.2a8.154,8.154,0,0,0,1.131,4.992,4.352,4.352,0,0,0,3.154,1.541v.577H31.79v-.577a3.748,3.748,0,0,0,3.5-1.955,10.741,10.741,0,0,0,.838-4.505V166.387a8.069,8.069,0,0,0-1.1-4.893,4.266,4.266,0,0,0-3.235-1.541v-.577H61.525a3.273,3.273,0,0,0,1.419-.212,2.315,2.315,0,0,0,.838-.9l2.847,15.962Z",
    transform: "translate(-3033.749 -385.58)",
    fill: "#72be44"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_22",
    "data-name": "Path 22",
    d: "M69.324,172.826v35.037c0,3.965,1.428,6.132,4.289,6.533v.577H58.3v-.554a4.505,4.505,0,0,0,3.037-1.518,7.582,7.582,0,0,0,1.23-5.014V179.278a6.451,6.451,0,0,0-.9-3.888,3.6,3.6,0,0,0-3.347-1.041v-.6l11.024-.9Zm-8.592-11.362a6.947,6.947,0,0,1,1.252-4.176,3.776,3.776,0,0,1,3.154-1.757,3.573,3.573,0,0,1,3.212,1.8,8.06,8.06,0,0,1,.05,8.227,3.483,3.483,0,0,1-3.154,1.757,3.744,3.744,0,0,1-3.262-1.757,6.825,6.825,0,0,1-1.252-4.091Z",
    transform: "translate(-3027.015 -386.261)",
    fill: "#72be44"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_23",
    "data-name": "Path 23",
    d: "M82.9,177.907a36.873,36.873,0,0,1,7.4-6.271,13.255,13.255,0,0,1,7.06-2.253,8.976,8.976,0,0,1,2.847.478,5.672,5.672,0,0,1,2.532,1.8,9.574,9.574,0,0,1,1.8,3.762,24.33,24.33,0,0,1,.676,6.343v22.648a8.33,8.33,0,0,0,1.068,4.915,4.429,4.429,0,0,0,3.262,1.541v.577H94.181v-.577a4.884,4.884,0,0,0,2.32-.964,4.992,4.992,0,0,0,1.279-1.667,5.338,5.338,0,0,0,.55-1.955c.063-.676.1-1.316.1-1.933V181.93a19.978,19.978,0,0,0-.212-2.946,6.966,6.966,0,0,0-.815-2.433,4.352,4.352,0,0,0-1.541-1.617,4.761,4.761,0,0,0-2.532-.6,8.307,8.307,0,0,0-3.951,1.041,10.027,10.027,0,0,0-3.347,3.059,17.211,17.211,0,0,0-2.307,5,24.241,24.241,0,0,0-.865,6.8v14.21a8.56,8.56,0,0,0,1.041,4.915,4.249,4.249,0,0,0,3.212,1.541v.577H71.74v-.577a4.293,4.293,0,0,0,3.154-1.518,8.109,8.109,0,0,0,1.1-4.956V179.524a22.942,22.942,0,0,0-.338-4.465,5.9,5.9,0,0,0-.9-2.433,2.6,2.6,0,0,0-1.379-1.041,7.142,7.142,0,0,0-1.617-.338v-.414l9.353-.6a16.41,16.41,0,0,1,1.131,3.6q.392,1.94.653,4.1Z",
    transform: "translate(-3023.601 -382.728)",
    fill: "#72be44"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_24",
    "data-name": "Path 24",
    d: "M125.386,176.3a14.821,14.821,0,0,0-5.33,1.23,13.218,13.218,0,0,0-4.55,3.4,16.383,16.383,0,0,0-3.185,5.645,24.779,24.779,0,0,0-1.153,7.961,24.221,24.221,0,0,0,.942,7.024,16.463,16.463,0,0,0,2.672,5.28,12.164,12.164,0,0,0,4.023,3.347,11.185,11.185,0,0,0,5.064,1.153,5.889,5.889,0,0,0,4.438-1.352,6.113,6.113,0,0,0,1.253-4.239v-29.1c-.964-.1-1.707-.189-2.253-.239a16.5,16.5,0,0,0-1.933-.1Zm11.024-19.373V207.5a11.181,11.181,0,0,0,.338,3.01,5.645,5.645,0,0,0,.9,1.933,3.347,3.347,0,0,0,1.352,1.1,8.69,8.69,0,0,0,1.667.5v.577H125.035a23.116,23.116,0,0,1-16.066-5.014,19.255,19.255,0,0,1-5.519-14.971,26.13,26.13,0,0,1,1.491-9.01,19.045,19.045,0,0,1,4.366-6.974,19.373,19.373,0,0,1,6.974-4.505,26.322,26.322,0,0,1,9.407-1.59c.626,0,1.266.027,1.933.05s1.3.077,1.933.126v-7.524a6.632,6.632,0,0,0-.9-3.924,3.564,3.564,0,0,0-3.3-1.014v-.577l11.024-2.771Z",
    transform: "translate(-3015.602 -385.896)",
    fill: "#72be44"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_25",
    "data-name": "Path 25",
    d: "M166.239,159.13v.577a4.956,4.956,0,0,0-3.109,1.568,7.714,7.714,0,0,0-1.153,4.956v14.3l9.353-10.871a58.628,58.628,0,0,0,4-4.956,5.617,5.617,0,0,0,1.18-3.059c0-1-.865-1.653-2.581-1.933v-.577h16.638v.577a14.8,14.8,0,0,0-3.037.816,14.1,14.1,0,0,0-2.946,1.568,26.6,26.6,0,0,0-3.347,2.771c-1.2,1.14-2.559,2.532-4.055,4.2l-3.838,4.366a63.284,63.284,0,0,1,9.064,13.745,96.829,96.829,0,0,1,5.141,13.241l.838,2.771q.642,2.257,1.352,4.1a23.335,23.335,0,0,0,1.419,3.185,6.713,6.713,0,0,0,1.8,2.117,4.474,4.474,0,0,0,2.482.9v.577H179.223v-.577a3.541,3.541,0,0,0,2.406-1.041,3.419,3.419,0,0,0,.752-2.293,26.425,26.425,0,0,0-.991-5.645,70.553,70.553,0,0,0-2.847-8.515,75.036,75.036,0,0,0-4.465-9.33,43.2,43.2,0,0,0-5.807-8.109L162,185.4v21.58a7.96,7.96,0,0,0,1.153,4.992,4.505,4.505,0,0,0,3.109,1.541v.577H150.38v-.581a3.748,3.748,0,0,0,3.5-1.955,10.739,10.739,0,0,0,.838-4.505V166.167a8.069,8.069,0,0,0-1.1-4.893,4.266,4.266,0,0,0-3.235-1.541v-.577h15.89Z",
    transform: "translate(-3003.625 -385.342)",
    fill: "#1976d2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_26",
    "data-name": "Path 26",
    d: "M207.858,187.809a33.039,33.039,0,0,0-6.4,2.221,23.339,23.339,0,0,0-4.956,3.154,13.282,13.282,0,0,0-3.154,3.888,9.462,9.462,0,0,0-1.131,4.465,6.582,6.582,0,0,0,1.469,4.415A5.348,5.348,0,0,0,198,207.646a8.474,8.474,0,0,0,7-3.712,17.03,17.03,0,0,0,2.847-10.506v-5.618Zm-14.633-16.467a31.618,31.618,0,0,1,4.176-1.3,26.579,26.579,0,0,1,6.271-.626,10.691,10.691,0,0,1,8.416,2.982,13.359,13.359,0,0,1,2.636,9.065v19.652a24.33,24.33,0,0,0,.365,4.7,11.507,11.507,0,0,0,.964,2.924,3.911,3.911,0,0,0,1.352,1.541,4.956,4.956,0,0,0,1.59.626v.577h-8.7a12.849,12.849,0,0,1-2.433-6.758,20.833,20.833,0,0,1-5.091,5.492,12.046,12.046,0,0,1-7.262,2.118,13.031,13.031,0,0,1-4.289-.7,10.109,10.109,0,0,1-3.446-2.045,9.911,9.911,0,0,1-3.221-7.551,11.475,11.475,0,0,1,1.541-5.879,15.547,15.547,0,0,1,4.505-4.753,33.2,33.2,0,0,1,7.186-3.811,90.2,90.2,0,0,1,9.592-3.109l.5-.077v-3.838a6.163,6.163,0,0,0-6.92-7.024,12.8,12.8,0,0,0-7.551,2.509,15.358,15.358,0,0,0-5.33,7.524l-.338.9-.415-.077,1.253-13.115a3.663,3.663,0,0,0,.789.626,1.716,1.716,0,0,0,.815.212,4.956,4.956,0,0,0,1.469-.239c.527-.176,1.054-.351,1.617-.527Z",
    transform: "translate(-2994.931 -382.772)",
    fill: "#1976d2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_27",
    "data-name": "Path 27",
    d: "M224.448,172.826v35.037c0,3.965,1.428,6.132,4.289,6.533v.577H213.419v-.554a4.505,4.505,0,0,0,3.037-1.518,7.583,7.583,0,0,0,1.23-5.014V179.278a6.45,6.45,0,0,0-.9-3.888,3.6,3.6,0,0,0-3.347-1.041v-.6l11.024-.9Zm-8.592-11.362a6.948,6.948,0,0,1,1.252-4.176,3.776,3.776,0,0,1,3.154-1.757,3.573,3.573,0,0,1,3.212,1.8,8.06,8.06,0,0,1,.049,8.227,3.483,3.483,0,0,1-3.154,1.757,3.744,3.744,0,0,1-3.262-1.757,6.826,6.826,0,0,1-1.253-4.1Z",
    transform: "translate(-2987.62 -386.261)",
    fill: "#1976d2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_28",
    "data-name": "Path 28",
    d: "M230.1,168.987a2.591,2.591,0,0,0,.626.9,2.974,2.974,0,0,0,1.955.451h22.157l-19.463,37.119a20.834,20.834,0,0,0,2.144.261c.725.05,1.469.077,2.194.077a19.751,19.751,0,0,0,9.461-2,12.245,12.245,0,0,0,5.492-7.447l.414.1-3.839,14.633c-.351-.275-.788-.6-1.3-.964a5.629,5.629,0,0,0-2.983-.549h-21.13l19.562-38.033c-1.469-.1-2.419-.176-2.87-.212s-.852-.05-1.23-.05a14.8,14.8,0,0,0-8.965,2.253,12.538,12.538,0,0,0-4.339,6.343l-.577-.162,2.672-12.727Z",
    transform: "translate(-2984.479 -382.832)",
    fill: "#1976d2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_29",
    "data-name": "Path 29",
    d: "M267.476,172.7a8.344,8.344,0,0,0-6.533,4.055,19.941,19.941,0,0,0-2.82,10.97l18.206-5.744a20.421,20.421,0,0,0-1.014-3.4,10.427,10.427,0,0,0-1.8-3.059,8.727,8.727,0,0,0-2.636-2.118,6.384,6.384,0,0,0-3.4-.707Zm-16.8,17.818a24.5,24.5,0,0,1,1.487-8.722,21.342,21.342,0,0,1,3.861-6.632,16.565,16.565,0,0,1,12.565-5.7,13.651,13.651,0,0,1,9.254,3.5,18.09,18.09,0,0,1,5.456,10.295L258.141,191.7a22.407,22.407,0,0,0,1.352,6.4,18.545,18.545,0,0,0,2.982,5.181,13.8,13.8,0,0,0,4.2,3.474,10.935,10.935,0,0,0,5.14,1.252,10.587,10.587,0,0,0,6.947-2.32,15.875,15.875,0,0,0,4.505-6.632h.577l-2.924,12.538a5.672,5.672,0,0,0-2.581-.725,10.211,10.211,0,0,0-3.109.626,14.418,14.418,0,0,1-4.577.626,20.467,20.467,0,0,1-8.078-1.541,19.037,19.037,0,0,1-6.308-4.388,19.57,19.57,0,0,1-4.109-6.816,25.318,25.318,0,0,1-1.469-8.83Z",
    transform: "translate(-2978.157 -382.713)",
    fill: "#1976d2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_30",
    "data-name": "Path 30",
    d: "M289.693,177.907a36.875,36.875,0,0,1,7.4-6.271,13.255,13.255,0,0,1,7.06-2.253,8.978,8.978,0,0,1,2.847.478,5.667,5.667,0,0,1,2.532,1.8,9.569,9.569,0,0,1,1.8,3.762,24.325,24.325,0,0,1,.676,6.343v22.648a8.331,8.331,0,0,0,1.068,4.915,4.429,4.429,0,0,0,3.262,1.541v.577H300.956v-.577a4.884,4.884,0,0,0,2.32-.964,4.993,4.993,0,0,0,1.28-1.667,5.339,5.339,0,0,0,.55-1.955c.063-.676.1-1.316.1-1.933V181.93a20,20,0,0,0-.212-2.946,6.963,6.963,0,0,0-.815-2.433,4.352,4.352,0,0,0-1.541-1.617,4.762,4.762,0,0,0-2.532-.6,8.308,8.308,0,0,0-3.951,1.041,10.026,10.026,0,0,0-3.347,3.059,17.208,17.208,0,0,0-2.293,4.992,24.25,24.25,0,0,0-.865,6.8v14.21a8.561,8.561,0,0,0,1.041,4.915,4.249,4.249,0,0,0,3.212,1.541v.577H278.52v-.577a4.293,4.293,0,0,0,3.154-1.518,8.108,8.108,0,0,0,1.1-4.956V179.52a22.929,22.929,0,0,0-.338-4.465,5.9,5.9,0,0,0-.9-2.433,2.6,2.6,0,0,0-1.379-1.041,7.148,7.148,0,0,0-1.617-.338v-.415l9.353-.6a16.4,16.4,0,0,1,1.126,3.6q.392,1.94.653,4.1Z",
    transform: "translate(-2971.081 -382.728)",
    fill: "#1976d2"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_335",
    "data-name": "Group 335",
    transform: "translate(-2904.141 -425.745)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_75",
    "data-name": "Path 75",
    d: "M106.2,0V188.824H249.156V0Z",
    transform: "translate(-106.2 -0.014)",
    fill: "url(#linear-gradient)"
  })), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_466",
    "data-name": "Rectangle 466",
    width: 142.956,
    height: 189.153,
    transform: "translate(-2904.141 -425.759)",
    fill: "none"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNewFkcroplogo);
export default __webpack_public_path__ + "static/media/newFKCROPLOGO.867674e8d57ecb9036327e6965320f93.svg";
export { ForwardRef as ReactComponent };